import { Link } from "react-router-dom";

import "./style.css";
import { DRYawnFreetrial, DRYawnFullBody, DRYawnSignup, DRYawnTitle, iphoneMockup, logo, LogoHorizontal } from "../../Assets/images";
import { Tick } from "../../Assets/svg";
import { useTranslation } from "react-i18next";

const Upgrade = () => {
    const { t } = useTranslation();
    const benefitsFromTranslation = t("freeTrial.benefits", { returnObjects: true });
    const benefits = Array.isArray(benefitsFromTranslation) ? benefitsFromTranslation : [];

    return (
        <>
            <style>
                {`body {
                overflow: hidden;
                height: 100vh;
            } #root{ height: 100% }`}
            </style>
            <div className="promo-classes fullPageBg d-flex flex-column align-items-center h-100 py-3 overflow-auto">
                <div className="d-flex align-items-center justify-content-between w-100 px-5 py-3">
                    <img src={logo} alt="Logo Horizontal" style={{ maxWidth: 120 }} className="img-fluid w-100" />
                    <Link to={'https://relaxscofa.com/dr-yawn-bio/'} target="_blank" rel="noopener noreferrer">
                        <img src={DRYawnTitle} alt="Logo" style={{ maxWidth: 115 }} className="img-fluid w-100" />
                    </Link>
                </div>
                <br />
                <div className="container-lg mt-4">
                    <div className="row">
                        <div className="col-12 text-center">
                            <p className="membership-title text-center w-100">{t("freeTrial.headline")}</p>
                            {/* <p className="membership-sub-title w-100 mb-0">{t("freeTrial.subheadlineLine1")} <br /> </p>
                            <p className="membership-sub-title w-100 px-5 px-lg-0 mb-0">
                                {t("freeTrial.subheadlineLine2")}  <br className="d-md-none" />{t("freeTrial.subheadlineLine3")}
                            </p> */}
                        </div>
                    </div>
                </div>
                <div className='container-lg membership-container mb-5 mb-sm-0'>
                    <div className="row ms-lg-4">
                        <div className="col-md-6 ms-xl-3 ml-md-0">
                            <div className="d-flex justify-content-center justify-content-md-end align-items-center" style={{ height: '100%' }}>
                                <img src={iphoneMockup} alt="iPhone Mockup" className="img-fluid membership-image" />
                            </div>
                        </div>
                        <div className="col-md-6  col-xl-5 align-self-center mt-0 mt-sm-0 ">
                            <div className="row mb-4 mt-md-0">
                                <div className="col-8 col-md-12 col-xl-12 mx-auto">
                                    <h5 className="membership-title my-2 text-center text-md-start text-nowrap">{t("freeTrial.supportMessage")}</h5>
                                    <div className="ps-md-0 align-list-box ">
                                        <ListItem icon={Tick} data={benefits} />
                                    </div>
                                </div>
                            </div>
                            <div className="row" >
                                <div className="col-12 col-md-12 mx-auto">
                                    <div className="text-center">
                                        <p className="text-line-height-1 text-center text-md-start mb-2">{t("freeTrial.ctaHeadline")}</p>
                                        <p className="text-line-height-2 text-center text-md-start fw-light mb-3">
                                            {t("freeTrial.ctaSubheadline")}
                                        </p>
                                        <div className="d-flex align-items-end justify-content-center justify-content-md-start mt-0">
                                            <Link to={"/signup"} className="btn rounded-5 px-4 py-2 stop-color " style={{ backgroundColor: '#EFB729', fontSize: '12px' }}>
                                                {t("freeTrial.continueButton")}
                                            </Link>
                                        </div>
                                        <br />
                                        <br />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6  col-xl-6  mt-4 d-none">
                            <div className="w-100 mx-auto ms-md-start">
                                <div className="row  mb-4 mt-3 mt-md-0 ms-lg-4">
                                    <div className="col-11 col-md-12 col-xl-12 mx-auto">
                                        <p className="text-center text-md-start align-list-box-freetrial ms-lg-0 ms-md-4 bullet-point mb-4">
                                            {t("freeTrial.supportMessage")}
                                        </p>
                                        <div className="ps-md-0 px-4 ms-4 ms-lg-0 mb-2">
                                            <ListItem icon={Tick} data={benefits} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mx-md-3 px-lg-2 mx-1 ">
                                    <div className="col-12 col-xl-12">
                                        <div className="text-start">
                                            <p className="text-center text-md-start free-trial-bottom-heading mb-0">
                                                {t("freeTrial.ctaHeadline")}
                                            </p>
                                            <p className="text-center text-md-start free-trial-bottom-heading-sub">
                                                {t("freeTrial.ctaSubheadline")}
                                            </p>
                                            <div className="d-flex justify-content-center justify-content-md-start pt-2 pt-ms-4 mt-4">
                                                <Link to={"/signup"} className="btn rounded-5 px-4 py-2 stop-color " style={{ backgroundColor: '#EFB729', fontSize: '12px' }}>
                                                    {t("freeTrial.continueButton")}
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="dr-yawn-freetrial-img-container text-center">
                        <img src={DRYawnFullBody} alt="Logo" className="img-fluid w-100"/>
                        <div className="dr-yawn-freetrial-content dr-yawn-content-text">
                            <img src={DRYawnTitle} alt="Logo" style={{maxWidth: 75}} className="img-fluid w-100" />
                            {/* <h4>Dr. Yawn</h4> */}
                            <span style={{ opacity: 0 }}>Scofa Mascot</span>
                        </div>
                    </div>
                    <br />
                    <br />
                </div>
            </div>
        </>
    );
};

const ListItem = ({ data, icon }) => {
    return (
        <ul className="listing-with-icon">
            {data.map((item, index) => (
                <li className=" " key={index}>
                    <img src={icon} className="tick-style" />
                    <span className="bullet-point-items">{item}</span>
                </li>
            ))}
        </ul>
    )
}
export default Upgrade;
